{
  "general": {
    "dateFormat": "dd/MM/yyyy",
    "fullDateFormat": "dd/MM/yyyy HH:mm:ss",
    "logout": "Disconnessione",
    "account": "Account",
    "profile": "Profilo",
    "hello": "Ciao",
    "home": "Home",
    "loading": "Caricamento...",
    "confirm": "Conferma",
    "cancel": "Annulla",
    "close": "Chiudi",
    "save": "Salva",
    "records": "Record",
    "add": "Aggiungi",
    "read": "Leggi",
    "write": "Salva",
    "edit": "Modifica",
    "new": "Nuovo",
    "delete": "Elimina",
    "actions": "Azioni",
    "active": "Attivo",
    "inactive": "Inattivo",
    "search": "Cerca",
    "yes": "Sì",
    "no": "No",
    "years": "Anni",
    "months": "Mesi",
    "favorites": "Preferiti",
    "reports": "Report",
    "recordsPerPage": "Record per pagina",
    "changePassword": "Cambia password",
    "longDateFormat": "{years} anno/i e {months} mese/i",
    "importData": "Importa dati",
    "upload": "Carica",
    "downloadTemplate": "Scarica modello",
    "selectOption": "Seleziona un'opzione",
    "id": "ID",
    "translations": "Traduzioni",
    "or": "o",
    "review": "Rivedi",
    "approve": "Approva",
    "reject": "Rifiuta",
    "reviewComments": "Commenti di Revisione",
    "reviewOnBehalfOf": "Rivedi per conto di",
    "reviewed": "Rivisto",
    "reviewedBy": "Rivisto Da ",
    "pending": "In sospeso",
    "approved": "Approvato",
    "rejected": "Rifiutato",
    "skipped": "Saltato",
    "warning": "Avviso",
    "leave": "Esci",
    "export": "Esporta",
    "import": "Importa",
    "next": "Avanti",
    "previous": "Indietro",
    "done": "Fatto",
    "permissionActions": {
      "read": "Leggi",
      "write": "Scrivi",
      "delete": "Elimina",
      "execute": "Esegui"
    },
    "messages": {
      "formUnsavedChanges": "Hai modifiche non salvate. Sei sicuro di voler chiudere?",
      "serverError": "Errore del server. Riprova più tardi o contatta l'amministratore del sistema.",
      "networkError": "Impossibile connettersi al server. Controlla la tua connessione internet o contatta l'amministratore del sistema.",
      "forbidden": "Non hai l'autorizzazione per accedere a questa risorsa. Contatta l'amministratore del sistema se pensi che sia un errore.",
      "fileUploadError": "Errore durante il caricamento del file. Controlla il formato e la dimensione del file e riprova.",
      "fileUploadSuccessEmail": "File caricato con successo. Un'email con il risultato dell'importazione verrà inviata a breve.",
      "failedLoadPermissions": "Caricamento delle autorizzazioni utente fallito. Aggiorna la pagina o contatta l'amministratore del sistema.",
      "downloadingFile": "Download del file in corso...",
      "fileDownloadError": "Errore durante il download del file. Riprova o contatta l'amministratore del sistema.",
      "fileImportedSuccessfully": "File importato con successo."
    },
    "warnings": {
      "maxDisplayedRecords": "Il numero massimo di record visualizzati è 500. Per vedere più record, usa la ricerca."
    },
    "validation": {
      "required": "Questo campo è obbligatorio.",
      "email": "Inserisci un indirizzo email valido.",
      "minValue": "Il valore deve essere almeno {min}.",
      "maxValue": "Il valore non può essere maggiore di {max}.",
      "onlyIntegers": "Il valore deve essere un numero intero.",
      "invalidDate": "La data inserita non è valida."
    },
    "baseAuditableEntity": {
      "createdBy": "Creato da",
      "createdDate": "Data di creazione",
      "modifiedBy": "Modificato da",
      "modifiedDate": "Data di modifica"
    }
  },
  "reportViewer": {
    "noFilterMessage": "Nessun filtro per questo report",
    "noAccessReport": "Non hai accesso a questo report. Contatta l'amministratore del sistema se pensi che sia un errore.",
    "pdfSizeErrorMessage": "La dimensione del PDF è troppo grande e non può essere visualizzata.",
    "pdfMaxSizeDownloaded": "Il report è troppo grande per essere visualizzato. Controlla la tua cartella download.",
    "failedLoadReports": "Caricamento report fallito. Le altre funzionalità funzioneranno normalmente. Aggiorna la pagina o contatta l'amministratore del sistema se il problema persiste.",
    "run": "Esegui",
    "download": "Scarica",
    "viewFilter": {
      "button": "Visualizza Filtri...",
      "title": "Parametri",
      "name": "Nome",
      "value": "Valore"
    },
    "fullScreen": "Schermo Intero...",
    "smallScreen": "Schermo Piccolo...",
    "tabButton": {
      "fullScreen": "Nascondi sezione parametri",
      "smallScreen": "Mostra sezione parametri",
      "about": "Info",
      "downloadExcel": "Scarica file Foglio di Calcolo",
      "clear": "Chiudi Tutte le Schede"
    },
    "modalAbout": {
      "title": "Info",
      "description": "Descrizione",
      "version": "Versione",
      "reference": "Riferimento",
      "lastChange": "Ultima Modifica",
      "dataSource": "Origine Dati"
    }
  },
  "file": {
    "description": "Descrizione",
    "files": "File",
    "editDescription": "Modifica Descrizione",
    "delete": "Elimina File",
    "download": "Scarica File",
    "pendingUpload": "Caricamento in sospeso. Il file verrà salvato solo dopo aver cliccato su 'Salva'.",
    "noFiles": "Nessun file aggiunto."
  },
  "404": {
    "title": "Questa pagina non è stata trovata.",
    "text": "La pagina richiesta non è stata trovata.",
    "back_button": "Torna alla dashboard"
  },
  "403": {
    "title": "Non hai l'autorizzazione per accedere a questa pagina.",
    "text": "Se pensi che sia un errore, contatta l'amministratore.",
    "back_button": "Torna alla dashboard"
  },
  "401": {
    "title": "Non sei autorizzato ad accedere a questa pagina.",
    "text": "Se pensi che non sia corretto, contatta l'amministratore",
    "back_button": "Torna alla dashboard"
  },
  "dashboard": {
    "menuTitle": "Dashboard",
    "title": "Dashboard",
    "addWidget": "Aggiungi Widget",
    "editLayout": "Modifica Layout",
    "saveLayout": "Salva Layout",
    "importLayout": "Importa Layout",
    "exportLayout": "Esporta Layout",
    "category": "Categoria",
    "widget": "Widget",
    "widgetTitle": "Titolo",
    "widgetParameters": "Parametri",
    "widgetInformation": "Informazioni Widget",
    "noParameters": "Questo widget non ha parametri.",
    "delete": "Elimina Widget",
    "viewLink": "visualizza",
    "messages": {
      "saveSuccess": "Layout salvato con successo.",
      "importSuccess": "Layout importato con successo.",
      "exportSuccess": "Layout esportato con successo.",
      "importFailed": "Importazione layout fallita.",
      "widgetNotFound": "Widget non trovato",
      "failedToLoad": "Caricamento fallito",
      "noDataAvailable": "Nessun dato disponibile"
    },
    "tutorial": {
      "mainMessage": "Benvenuto nella tua dashboard! Usa i pulsanti sopra per personalizzarla.",
      "callToAction": "Mostrami come!",
      "instructions": {
        "add": {
          "title": "Pulsante Aggiungi Widget",
          "description": "Qui potrai trovare widget per categoria. Alcuni di essi possono avere parametri per permetterti una dashboard completamente personalizzabile. Non dimenticare di premere SALVA dopo aver aggiunto tutti i tuoi widget."
        },
        "edit": {
          "title": "Modifica Layout Widget",
          "description": "Qui potrai modificare la tua dashboard: Aggiungere o rimuovere widget, spostarli e ridimensionarli. Non dimenticare di salvare dopo la modifica."
        },
        "import": {
          "title": "Importa Layout",
          "description": "Con un file di backup, qui puoi importarlo. Nota: La tua dashboard sarà sovrascritta."
        },
        "export": {
          "title": "Esporta Layout",
          "description": "Una volta completata la tua dashboard, puoi esportarla per avere un backup OPPURE inviarla ad un altro utente per copiare la tua dashboard."
        }
      }
    }
  },
  "settings": {
    "title": "Impostazioni",
    "theme": {
      "name": "Tema",
      "dark": "Scuro",
      "light": "Chiaro"
    }
  },
  "userInfo": {
    "title": "Informazioni Utente",
    "permissions": "Autorizzazioni",
    "userName": "Nome utente",
    "fullName": "Nome Completo",
    "email": "Email",
    "employeeId": "ID Dipendente",
    "action": "Azione",
    "permissionCode": "Codice Autorizzazione"
  },
  "impersonate": {
    "title": "Impersona Utente",
    "userName": "Login",
    "start": "Inizia Impersonificazione",
    "messages": {
      "impersonationStarted": "Sessione di impersonificazione iniziata. Per tornare al tuo account, effettua il logout e riconnettiti.",
      "userNotFound": "Utente non trovato. Controlla il nome utente e riprova."
    }
  },
  "about": {
    "menuName": "Info",
    "title": "Info"
  },
  "releaseNotes": {
    "menuName": "Note di Rilascio",
    "title": "Note di Rilascio",
    "name": "Nome",
    "version": "Versione",
    "description": "Descrizione",
    "appType": "Tipo Applicazione",
    "releaseDate": "Data di Rilascio",
    "messages": {
      "notFound": "Nota di rilascio non trovata.",
      "saveError": "Errore nel salvataggio della nota di rilascio. Riprova più tardi."
    }
  },
  "admin": {
    "menuTitle": "Amministrazione",
    "menuHierarchy": {
      "menuName": "Gerarchia Menu",
      "pageTitle": "Gerarchia Menu",
      "displayName": "Nome Visualizzato",
      "routeParam": "Parametro Menu",
      "securityResources": "Risorse di Sicurezza",
      "children": "Sotto-Menu",
      "isActive": "È Attivo",
      "icon": "Icona",
      "displayOrder": "Ordine di Visualizzazione",
      "edit": "Modifica Elemento Menu",
      "messages": {
        "success": "Elemento menu salvato con successo."
      }
    },
    "notificationTemplate": {
      "menuName": "Template Notifica",
      "pageTitle": "Template Notifica",
      "name": "Nome",
      "parent": "Template Genitore",
      "parentInfo": "Solo i template che iniziano con masterTemplate possono essere usati come template genitore.",
      "pushNotificationEnabled": "Notifica Push Abilitata",
      "pushRoute": "Route Notifica Push",
      "sqlQuery": "Query SQL",
      "sqlQueryDateFormatInfo": "Le colonne data devono essere formattate nel formato MM/dd/yyyy.",
      "generalSection": "Informazioni Generali",
      "emailSection": "Notifica Email",
      "emailSubject": "Oggetto Email",
      "emailBody": "Corpo Email (HTML)",
      "pushSection": "Notifica Push",
      "pushSubject": "Oggetto Push",
      "pushBody": "Corpo Push",
      "overrideNotificationTemplate": "Sovrascrivi Template Notifica",
      "add": "Aggiungi Template",
      "edit": "Modifica Template",
      "delete": {
        "title": "Elimina Template",
        "text": "Sei sicuro di voler eliminare il template \"{name}\"?"
      },
      "messages": {
        "created": "Template notifica creato con successo.",
        "updated": "Template notifica aggiornato con successo.",
        "deleted": "Template notifica eliminato con successo.",
        "alreadyExists": "Un template notifica con questo nome esiste già.",
        "fileRequired": "Il file è obbligatorio.",
        "importError": "Si è verificato un errore durante l'importazione del template notifica."
      }
    },
    "department": {
      "menuName": "Dipartimento",
      "pageTitle": "Dipartimento",
      "name": "Nome",
      "isActive": "È Attivo",
      "add": "Aggiungi Dipartimento",
      "edit": "Modifica Dipartimento",
      "delete": {
        "title": "Elimina Dipartimento",
        "text": "Sei sicuro di voler eliminare questo dipartimento?"
      },
      "messages": {
        "created": "Dipartimento creato con successo.",
        "updated": "Dipartimento aggiornato con successo.",
        "deleted": "Dipartimento eliminato con successo."
      }
    },
    "businessArea": {
      "menuName": "Area di Business",
      "pageTitle": "Area di Business",
      "id": "Id",
      "externalId": "Id Esterno",
      "description": "Descrizione",
      "calendarId": "Calendario",
      "isActive": "È Attivo",
      "edit": "Modifica Area di Business",
      "messages": {
        "created": "Area di Business creata con successo.",
        "updated": "Area di Business aggiornata con successo.",
        "deleted": "Area di Business eliminata con successo."
      }
    },
    "configuration": {
      "menuName": "Configurazione",
      "pageTitle": "Configurazione",
      "key": "Chiave",
      "value": "Valore",
      "editorType": "Tipo",
      "add": "Aggiungi Configurazione",
      "edit": "Modifica Configurazione",
      "delete": {
        "title": "Elimina Configurazione",
        "text": "Sei sicuro di voler eliminare questa configurazione?"
      },
      "messages": {
        "created": "Configurazione creata con successo.",
        "updated": "Configurazione aggiornata con successo.",
        "deleted": "Configurazione eliminata con successo."
      },
      "types": {
        "text": "Testo",
        "string": "Stringa",
        "number": "Numero",
        "int": "Intero",
        "boolean": "Booleano"
      }
    },
    "widget": {
      "menuName": "Widget",
      "pageTitle": "Widget",
      "name": "Nome",
      "description": "Descrizione",
      "securityResources": "Risorse di Sicurezza",
      "link": "Link",
      "query": "Query SQL",
      "queryRequired": "La query SQL è obbligatoria.",
      "sqlQueryDateFormatInfo": "Le colonne data devono essere formattate nel formato MM/dd/yyyy.",
      "minHeight": "Altezza Minima",
      "minWidth": "Larghezza Minima",
      "type": "Tipo",
      "category": "Categoria",
      "add": "Aggiungi Widget",
      "edit": "Modifica Widget",
      "delete": {
        "title": "Elimina Widget",
        "text": "Sei sicuro di voler eliminare questo widget?"
      },
      "examples": {
        "viewSQLExamples": "Visualizza esempi SQL",
        "general": "Generale",
        "generalDescription": "Per default, il sistema fornisce i seguenti parametri, che possono essere referenziati direttamente in qualsiasi query SQL widget.",
        "loggedUserNameDescription": "Username di login dell'utente attualmente connesso (ad esempio: {email}).",
        "loggedUserEmployeeIdDescription": "Identificativo dipendente dell'utente attualmente connesso.",
        "loggedUserLanguageDescription": "Codice lingua dell'utente attualmente connesso (ad esempio: en-US, pt-BR).",
        "listDescription": "Ogni riga rappresenta un elemento della lista.",
        "numberDescription": "Restituisce un singolo valore numerico.",
        "donutDescription": "Le etichette e i valori devono essere allineati per posizione.",
        "lineDescription": "Ogni riga rappresenta una serie di linee."
      },
      "messages": {
        "created": "Widget creato con successo.",
        "updated": "Widget aggiornato con successo.",
        "deleted": "Widget eliminato con successo.",
        "fileRequired": "Il file è obbligatorio.",
        "importError": "Si è verificato un errore durante l'importazione del widget.",
        "queryVariablesMissing": "Le seguenti variabili sono assenti nella query del widget: \"{variables}\". Si prega di aggiungerle alla query per garantire il corretto funzionamento."
      }
    },
    "widgetCategory": {
      "menuName": "Categoria Widget",
      "pageTitle": "Categoria Widget",
      "name": "Nome",
      "description": "Descrizione",
      "type": "Tipo",
      "add": "Aggiungi Categoria Widget",
      "edit": "Modifica Categoria Widget",
      "delete": {
        "title": "Elimina Categoria Widget",
        "text": "Sei sicuro di voler eliminare questa categoria widget?"
      },
      "messages": {
        "created": "Categoria Widget creata con successo.",
        "updated": "Categoria Widget aggiornata con successo.",
        "deleted": "Categoria Widget eliminata con successo."
      }
    },
    "widgetType": {
      "menuName": "Tipo Widget",
      "pageTitle": "Tipo Widget",
      "name": "Nome",
      "types": {
        "number": "Numero",
        "list": "Lista",
        "donut": "Grafico ad anello",
        "line": "Linea"
      }
    },
    "widgetParameter": {
      "menuName": "Parametro Widget",
      "menuTitle": "Parametro Widget",
      "title": "Parametro Widget",
      "name": "Nome",
      "nameInfo": "Nome usato per identificare il parametro nella query SQL widget. Non usare spazi o caratteri speciali.",
      "nameUniqueError": "Un Parametro Widget con questo nome esiste già.",
      "description": "Descrizione",
      "isRequired": "È Obbligatorio?",
      "isMultiple": "È Multiplo?",
      "status": "Stato",
      "edit": "Modifica Parametro Widget",
      "add": "Aggiungi Parametro Widget",
      "type": "Tipo",
      "data": "Query SQL",
      "dataInfo": "La query SQL deve restituire due colonne chiamate 'Value' e 'Text'.",
      "listOfValues": "Lista di Valori",
      "addValue": "Aggiungi Valore",
      "value": "Valore",
      "label": "Etichetta",
      "delete": {
        "title": "Elimina Parametro Widget",
        "text": "Sei sicuro di voler eliminare {name}?"
      },
      "types": {
        "text": "Testo",
        "number": "Numero",
        "date": "Data",
        "boolean": "Booleano",
        "select": "Lista",
        "sql": "Lista Query"
      },
      "messages": {
        "notFound": "Parametro Widget non trovato.",
        "saveSuccess": "Parametro Widget salvato con successo.",
        "saveError": "Si è verificato un errore durante il salvataggio del Parametro Widget.",
        "deleteSuccess": "Parametro Widget eliminato con successo.",
        "deleteError": "Si è verificato un errore durante l'eliminazione del Parametro Widget.",
        "isInUse": "Impossibile eliminare il Parametro Widget perché è in uso."
      }
    },
    "people": {
      "employeeId": "ID Dipendente",
      "name": "Nome",
      "position": "Posizione",
      "person": "Persona",
      "personTypes": {
        "unknown": "Sconosciuto",
        "salariedEmployee": "Dipendente Stipendiato",
        "contractor": "Contrattista",
        "vendor": "Fornitore",
        "hourlyEmployee": "Dipendente Orario",
        "external": "Esterno",
        "duHourlyInactive": "DU Orario Inattivo",
        "duSalariedInactive": "DU Stipendiato Inattivo",
        "duTruckDriverIn": "DU Camionista Dentro",
        "executive": "Dirigente",
        "union": "Sindacalizzato",
        "nonUnion": "Non Sindacalizzato",
        "unionPossible": "Sindacalizzazione Possibile",
        "salariedNonExempt": "Stipendiato Non Esente",
        "hourly": "Orario",
        "duPaidLeave": "DU Congedo Retribuito",
        "truckDriver": "Camionista",
        "duUnpaidLeave": "DU Congedo Non Retribuito",
        "workRelease": "Rilascio Lavorativo",
        "externalAccessLevelOne": "Accesso Esterno Livello Uno",
        "externalAccessLevelTwo": "Accesso Esterno Livello Due",
        "externalAccessLevelThree": "Accesso Esterno Livello Tre",
        "externalAccessLevelFour": "Accesso Esterno Livello Quattro",
        "externalAccessLevelFive": "Accesso Esterno Livello Cinque",
        "globalEmployee": "Dipendente Globale"
      }
    }
  },
  "vuestic": {
    "search": "Cerca",
    "noOptions": "Elementi non trovati",
    "ok": "OK",
    "cancel": "Annulla",
    "uploadFile": "Seleziona file",
    "undo": "Annulla",
    "dropzone": "Trascina i file qui per caricare",
    "fileDeleted": "File eliminato",
    "closeAlert": "chiudi avviso",
    "backToTop": "torna all'inizio",
    "toggleDropdown": "attiva menu a discesa",
    "carousel": "carousel",
    "goPreviousSlide": "vai alla diapositiva precedente",
    "goNextSlide": "vai alla diapositiva successiva",
    "goSlide": "vai alla diapositiva {index}",
    "slideOf": "diapositiva {index} di {length}",
    "close": "chiudi",
    "openColorPicker": "apri selettore colore",
    "colorSelection": "selezione colore",
    "colorName": "colore {color}",
    "decreaseCounter": "diminuisci contatore",
    "increaseCounter": "aumenta contatore",
    "selectAllRows": "seleziona tutte le righe",
    "sortColumnBy": "ordina colonna per {name}",
    "selectRowByIndex": "seleziona riga {index}",
    "resetDate": "reimposta data",
    "nextPeriod": "periodo successivo",
    "switchView": "cambia vista",
    "previousPeriod": "periodo precedente",
    "removeFile": "rimuovi file",
    "reset": "reimposta",
    "pagination": "paginazione",
    "goToTheFirstPage": "vai alla prima pagina",
    "goToPreviousPage": "vai alla pagina precedente",
    "goToSpecificPage": "vai alla pagina {page}",
    "goToSpecificPageInput": "inserisci numero pagina",
    "goNextPage": "vai alla pagina successiva",
    "goLastPage": "vai all'ultima pagina",
    "currentRating": "valutazione attuale {value} di {max}",
    "voteRating": "vota valutazione {value} di {max}",
    "optionsFilter": "filtro opzioni",
    "splitPanels": "dividi pannelli",
    "movePaginationLeft": "sposta paginazione a sinistra",
    "movePaginationRight": "sposta paginazione a destra",
    "resetTime": "reimposta ora",
    "closeToast": "chiudi notifica",
    "selectedOption": "Opzione selezionata",
    "noSelectedOption": "Nessuna opzione selezionata",
    "breadcrumbs": "percorso di navigazione",
    "counterValue": "valore contatore",
    "selectedDate": "data selezionata",
    "selectedTime": "ora selezionata",
    "progressState": "stato avanzamento",
    "color": "colore",
    "next": "Avanti",
    "back": "Indietro",
    "finish": "Termina",
    "step": "passo",
    "progress": "avanzamento",
    "loading": "Caricamento",
    "sliderValue": "Il valore attuale del cursore è {value}",
    "switch": "Interruttore",
    "inputField": "Campo di input",
    "fileTypeIncorrect": "Tipo file non corretto",
    "select": "Seleziona un'opzione"
  }
}
